import { Elements } from '@/components';
import { Link } from '@/lib/router';
import LeaderShipTeamImage from '@images/LeaderShipTeam.webp';

interface LeaderShipTeamProps {
    title?: string;
    description?: string;
    subtitle?: string;
    subDescription?: string;
    subSubDescription?: string;
    backgroundImage?: string;
}

export const LeaderShipTeam = ({
    title = 'Leadership Team',
    description = 'Our team combines deep insurance industry expertise with cutting-edge technology experience.',
    subtitle = 'Built by Insurance Technology Veterans',
    subDescription = "Our founding team has decades of combined experience building technology solutions for the insurance industry. We've worked with brokers, carriers, and TPAs of all sizes, and we understand the unique challenges each faces in today's evolving benefits landscape.",
    subSubDescription = 'This deep industry knowledge, combined with our technical expertise in modern software development, allows us to build solutions that truly serve the needs of insurance professionals.',
}: LeaderShipTeamProps = {}) => {
    return (
        <section
            className="overflow-hidden bg-brand-50 px-5 pt-0 pb-20 md:px-10 lg:px-[79px]"
        >
            <div className="mx-auto flex w-full max-w-[1200px] flex-col items-center gap-[30px] lg:grid lg:grid-cols-2 lg:gap-[30px] lg:items-start">
                <div className="order-1 w-full lg:order-2 lg:col-start-2">
                    <div className="flex w-full flex-col items-center gap-4 lg:items-start">
                        <Elements.Title title={title} type="h1" className="text-center text-gray-900 lg:text-left" />
                        <Elements.Description description={description} type="medium" className="text-center text-gray-900 lg:text-left" />
                    </div>
                </div>
                
                <div className="order-2 w-full lg:order-1 lg:col-start-1 lg:row-span-2">
                    <img src={LeaderShipTeamImage} alt="Leadership Team" className="w-full h-auto object-cover" />
                </div>
                
                <div className="order-3 w-full lg:order-2 lg:col-start-2">
                    <div className="flex w-full flex-col items-start gap-4 lg:items-start">
                        <Elements.Title title={subtitle} type="h5" className="text-left text-gray-900 lg:text-left" />
                        <Elements.Description description={subDescription} type="medium" className="text-left text-gray-900 lg:text-left" />
                        <Elements.Description description={subSubDescription} type="medium" className="text-left text-gray-900 lg:text-left" />
                        <div className="flex w-full flex-col items-center justify-center gap-4 md:flex-row">
                            <Link
                                to="/company/founders"
                                className="btn btn-primary btn-lg h-[51px] min-h-[51px] w-full min-w-0 shrink-0 no-underline md:flex-1"
                            >
                                Meet Our Founders
                            </Link>
                            <Link
                                to="/company/advisors"
                                className="btn btn-white btn-lg h-[51px] min-h-[51px] w-full min-w-0 shrink-0 no-underline md:flex-1"
                            >
                                Meet Our Advisory Board
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
